import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { challengeAPI } from '../services/api';
import useApi from '../hooks/useApi';

const ChallengePlay = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [currentTask, setCurrentTask] = useState(0);
    const [solution, setSolution] = useState('');
    const [showResults, setShowResults] = useState(false);

    const { data: challenge, loading, error } = useApi(() => challengeAPI.getChallenge(id));

    if (loading) {
        return (
            <div className="container mt-5">
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger" role="alert">
                    Error loading challenge: {error.message}
                </div>
            </div>
        );
    }

    const handleSubmit = async () => {
        try {
            await challengeAPI.submitChallenge(id, {
                taskId: challenge.tasks[currentTask].id,
                solution
            });
            if (currentTask < challenge.tasks.length - 1) {
                setCurrentTask(currentTask + 1);
                setSolution('');
            } else {
                setShowResults(true);
            }
        } catch (error) {
            console.error('Error submitting solution:', error);
        }
    };

    if (showResults) {
        return (
            <div className="container mt-5">
                <div className="card">
                    <div className="card-body">
                        <h2 className="card-title">Challenge Completed!</h2>
                        <p className="card-text">
                            You have completed the challenge. Your results will be available shortly.
                        </p>
                        <button
                            className="btn btn-primary"
                            onClick={() => navigate('/dashboard')}
                        >
                            Return to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const task = challenge.tasks[currentTask];

    return (
        <div className="container mt-5">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="card-title mb-0">{challenge.title}</h2>
                        <span className="badge bg-primary">
                            Task {currentTask + 1} of {challenge.tasks.length}
                        </span>
                    </div>

                    <div className="progress mb-4">
                        <div
                            className="progress-bar"
                            role="progressbar"
                            style={{
                                width: `${((currentTask + 1) / challenge.tasks.length) * 100}%`
                            }}
                        />
                    </div>

                    <div className="mb-4">
                        <h4>Task Description</h4>
                        <p>{task.description}</p>
                    </div>

                    <div className="mb-4">
                        <h4>Your Solution</h4>
                        <textarea
                            className="form-control"
                            rows="10"
                            value={solution}
                            onChange={(e) => setSolution(e.target.value)}
                            placeholder="Write your solution here..."
                        />
                    </div>

                    <div className="d-flex justify-content-between">
                        <button
                            className="btn btn-secondary"
                            onClick={() => {
                                if (currentTask > 0) {
                                    setCurrentTask(currentTask - 1);
                                    setSolution('');
                                }
                            }}
                            disabled={currentTask === 0}
                        >
                            Previous Task
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={!solution.trim()}
                        >
                            {currentTask === challenge.tasks.length - 1 ? 'Finish Challenge' : 'Submit & Next Task'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChallengePlay; 